<script>
  export let size = 18;

  export let title = undefined;

  $: labelled = $$props["aria-label"] || $$props["aria-labelledby"] || title;
  $: attributes = {
    "aria-hidden": labelled ? undefined : true,
    role: labelled ? "img" : undefined,
    focusable: Number($$props["tabindex"]) === 0 ? true : undefined,
  };
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  fill="currentColor"
  preserveAspectRatio="xMidYMid meet"
  width="{size}"
  height="{size}"
  {...attributes}
  {...$$restProps}
>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M8.35 13.3498H9.05V7.9998H8.35V13.3498ZM8.7 6.7498C8.84167 6.7498 8.96042 6.70189 9.05625 6.60605C9.15208 6.51022 9.2 6.39147 9.2 6.2498C9.2 6.10814 9.15208 5.98939 9.05625 5.89355C8.96042 5.79772 8.84167 5.7498 8.7 5.7498C8.55833 5.7498 8.43958 5.79772 8.34375 5.89355C8.24792 5.98939 8.2 6.10814 8.2 6.2498C8.2 6.39147 8.24792 6.51022 8.34375 6.60605C8.43958 6.70189 8.55833 6.7498 8.7 6.7498ZM8.70435 17.6998C7.50145 17.6998 6.37035 17.4715 5.31105 17.015C4.25173 16.5585 3.33028 15.9389 2.54668 15.1563C1.76309 14.3737 1.14275 13.4534 0.68565 12.3955C0.22855 11.3375 0 10.2071 0 9.00416C0 7.80126 0.228259 6.67016 0.684775 5.61086C1.14131 4.55154 1.76087 3.63009 2.54347 2.8465C3.32609 2.0629 4.24638 1.44256 5.30435 0.985455C6.36232 0.528355 7.49275 0.299805 8.69565 0.299805C9.89855 0.299805 11.0296 0.528063 12.0889 0.984579C13.1483 1.44111 14.0697 2.06068 14.8533 2.84328C15.6369 3.6259 16.2572 4.54619 16.7143 5.60416C17.1714 6.66212 17.4 7.79255 17.4 8.99545C17.4 10.1984 17.1717 11.3295 16.7152 12.3888C16.2587 13.4481 15.6391 14.3695 14.8565 15.1531C14.0739 15.9367 13.1536 16.5571 12.0956 17.0142C11.0377 17.4713 9.90725 17.6998 8.70435 17.6998ZM8.7 16.9998C10.9333 16.9998 12.825 16.2248 14.375 14.6748C15.925 13.1248 16.7 11.2331 16.7 8.9998C16.7 6.76647 15.925 4.8748 14.375 3.3248C12.825 1.7748 10.9333 0.999805 8.7 0.999805C6.46667 0.999805 4.575 1.7748 3.025 3.3248C1.475 4.8748 0.7 6.76647 0.7 8.9998C0.7 11.2331 1.475 13.1248 3.025 14.6748C4.575 16.2248 6.46667 16.9998 8.7 16.9998Z"
  />
</svg>
